import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {SharedService} from "../../services/shared.service";
import {Router} from "@angular/router";
import {EventTypes} from "../../event-types";
import {NgIf} from "@angular/common";
import {animate, keyframes, state, style, transition, trigger} from "@angular/animations";
import { ReportBannerService } from 'src/app/services/report-banner.service';

@Component({
  selector: 'app-report-banner',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './report-banner.component.html',
  styleUrl: './report-banner.component.scss',
  animations: [
    trigger('dropDown', [
      state('in', style({
        opacity: 1,
        transform: 'translateY(0) scale(1)'
      })),
      transition('void => *', [
        animate('0.3s cubic-bezier(0.25, 0.5, 0.75, 1)', keyframes([
          style({ opacity: 0, transform: 'translateY(-100%) scale(0.5)', offset: 0 }),
          style({ opacity: 1, transform: 'translateY(0) scale(1)', offset: 0.5 }),
          style({ opacity: 1, transform: 'translateY(0) scale(1)', offset: 1 })
        ]))
      ]),
      transition('* => void', [
        animate('0.3s ease-out', style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }))
      ])
    ])
  ]
})
export class ReportBannerComponent implements OnInit, OnDestroy {
  private eventSubscription: Subscription;

  showReportLoadingBanner: boolean = false
  showReportGeneratedBanner: boolean = false
  showReportNotGeneratedGeneratedBanner: boolean = false
  isBulkUpload: boolean = false // Track if this is a bulk upload banner
  reportMessage: string = 'Please wait, the report is generated...' // Default message

  changeCompany: any = {
    message: null,
    showLoading: false,
    showBanner: false
  }

  reportId: number = null
  reportName: string = null

  constructor(
    private sharedService: SharedService,
    private routerService: Router,
    private reportBannerService: ReportBannerService
  ) {}

  ngOnInit() {
    this.eventSubscription = this.sharedService.eventEmitter.subscribe(event => {
      // First, check if this is a bulk upload mode and we should skip individual banners
      if (this.reportBannerService.isInBulkUploadMode()) {
        if (event.type === EventTypes.SHOW_REPORT_BANNER ||
          event.type === EventTypes.REPORT_NOT_GENERATED) {
          // Skip individual report banners completely when in bulk mode
          return;
        }

        // Only allow SHOW_LOADING_REPORT_BANNER if it has isBulkUpload flag
        if (event.type === EventTypes.SHOW_LOADING_REPORT_BANNER &&
          (!event.data || !event.data.isBulkUpload)) {
          return;
        }
      }

      // Process allowed events
      if (event.type === EventTypes.SHOW_LOADING_REPORT_BANNER) {
        // Check if this is a bulk upload banner
        if (event.data && event.data.isBulkUpload) {
          this.isBulkUpload = true;
          this.reportMessage = event.data.message || 'Reports are generating for all contacts. Please wait...';
        } else {
          this.isBulkUpload = false;
          this.reportMessage = 'Please wait, the report is generated...';
        }

        this.showReportLoadingBanner = true
        this.showReportGeneratedBanner = false
        this.showReportNotGeneratedGeneratedBanner = false
      }

      if (event.type === EventTypes.SHOW_REPORT_BANNER) {
        this.showReportLoadingBanner = false
        this.showReportGeneratedBanner = true
        this.showReportNotGeneratedGeneratedBanner = false

        this.reportId = event.data.report_id
        this.reportName = event.data.report_name

        // Only auto-redirect if not in bulk mode and if we have a report ID
        if (!this.isBulkUpload && this.reportId) {
          // this.routerService.navigate(['/report/' + this.reportId]);
        }

        setTimeout(() => {
          this.closeReportGeneratedBanner();
        }, 5000); // 5000 milliseconds = 5 seconds
      }

      if (event.type === EventTypes.CLOSE_REPORT_BANNER) {
        this.showReportLoadingBanner = false
        this.showReportGeneratedBanner = false
        this.showReportNotGeneratedGeneratedBanner = false
        this.isBulkUpload = false
      }

      if (event.type === EventTypes.REPORT_NOT_GENERATED) {
        this.showReportLoadingBanner = false
        this.showReportGeneratedBanner = false
        this.showReportNotGeneratedGeneratedBanner = true

        setTimeout(() => {
          this.closeReportGeneratedBanner();
        }, 5000); // 5000 milliseconds = 5 seconds
      }

      if (event.type === EventTypes.SEARCH_ERROR) {
        this.showReportLoadingBanner = false
        this.showReportGeneratedBanner = false
        this.showReportNotGeneratedGeneratedBanner = false
        this.isBulkUpload = false
      }
    });

    // Change Company Banner
    this.sharedService.changeCompanyBanner$.subscribe((data): void => {
      if (data) {
        this.changeCompany = {
          message: data.message,
          showLoading: data.showLoading,
          showBanner: data.showBanner,
        }

        if(!data.showLoading) {
          // Automatically reset or perform an action after 5 seconds
          setTimeout(() => {
            this.closeChangeCompanyBanner()
          }, 5000); // 5000 milliseconds = 5 seconds
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  viewReport () {
    console.log('viewReport')

    this.routerService.navigate(['/report/' + this.reportId]);

    this.showReportGeneratedBanner = false
  }

  closeReportLoadingBanner () {
    this.showReportLoadingBanner = false
    this.isBulkUpload = false
  }

  closeReportGeneratedBanner () {
    this.showReportGeneratedBanner = false
    this.showReportNotGeneratedGeneratedBanner = false
    this.isBulkUpload = false
  }

  closeChangeCompanyBanner () {
    this.changeCompany = {
      message: null,
      showLoading: false,
      showBanner: false
    }
  }
}
